import HelpPageComponent from './help-page.component';
import PublicHelpPageComponent from './public-help-page.component';

export {
  HelpPageComponent,
  PublicHelpPageComponent
}



// WEBPACK FOOTER //
// src/help/index.js